








































import Vue from 'vue'
import { mapActions } from 'vuex'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/figurePainting'
import FileUpload from '@/components/FileUpload.vue'
import { FigurePaintingForm } from '@/interfaces/figurePainting'

export default Vue.extend({
  name: 'FigurePaintingImage',
  components: {
    FileUpload
  },
  computed: {
    form (): FigurePaintingForm {
      return this.$store.state.figurePainting.form
    }
  },
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.IMAGE)
  },
  mounted () {
    this.handleImageUpdate(null)
  },
  methods: {
    ...mapActions('figurePainting', [
      'handleImageUpdate'
    ]),
    handleFileChange (event: Event & DragEvent) {
      const { $route: { query } } = this
      const eventTarget = event.dataTransfer
        ? event.dataTransfer
        : event.target as EventTarget & HTMLInputElement
      const { files } = eventTarget || {}
      const [file] = files || []

      this.handleImageUpdate(file)
        .then(() => {
          this.$router.push({ path: 'submit', query })
        })
        .catch((error: Error) => {
          this.$bvModal
            .msgBoxOk(error.message, {
              centered: true,
              footerClass: 'msgbox-confirm-footer',
              okTitle: '確認'
            })
        })
    }
  }
})
